import { Component } from '@angular/core';
import { BaseComponent } from '@varsity/components';
import {
    LoggingService, TokenService, LocalStorageService,
    NotificationsService, PlatformService
} from "@varsity/services";
import { ToastController, PopoverController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';

/**
 * Generated class for the HeaderComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'header',
    templateUrl: 'header.html'
})
export class HeaderComponent extends BaseComponent {

    constructor(
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected toastCtrl: ToastController,
        protected popoverCtrl: PopoverController,
        protected platformService: PlatformService,
        protected iab: InAppBrowser,
    ) {

        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "HeaderComponent");
    }

}



// WEBPACK FOOTER //
// ./src/components/header/header.ts